<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      class="elinput"
      @click="newCustomer"
      v-if="Permission.indexOf(136)!=-1"
    >{{$t('lang.customermanagement.Add')}}</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-top: 0.2rem;margin-bottom: 0.2rem" v-if="Permission.indexOf(140)!=-1"></xlsx>
<!--    表格组件-->
    <TableComponent
      :data="list"
      :RowKey="'c_id'"
      :ColuumnsButtonWidth="140"
      :Columns="Columns"
      :ColuumnsButton="ColuumnsButton"
      :seek="seek"
      @modificationCustomer="modificationCustomer"
      @deleteCustomer="deleteCustomer"
      @GetServer="GetServer"
      @sortChange="sortChange"
    />
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 修改增加 -->
    <cont-dialog ref="contDialog" @getList="getCustomerList" @queryKeyword="queryKeyword"></cont-dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import UserMap from "@/components/map";
import contDialog from './component/contDialog'
import {
  getCustomerList,
  newCustomer,
  deleteCustomer,
  getFunctionalAuthority,
  updateCustomer,
  queryKeyword
} from "@/api/customermanagement";
import { getPermission,getToken } from "../../../cookie/cookie";
import { PublicComponent } from "../../../mixins/common";
import TableComponent from '@/components/TableComponent/index'
import { Columns,ColuumnsButton } from './TableConfig'

export default {
  mixins: [PublicComponent],
  name: 'customermanagement',
  data() {
    return {
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      //权限数组
      Permission: [],
      list: [],
      total:0,
      offset:1,
      limit:10,
      value: "",
      productType: [
        {
          value: "0",
          label: this.$t('lang.customermanagement.StandardService')
        },
        {
          value: "1",
          label: "SuperLink"
        },
        {
          value: "2",
          label: this.$t('lang.customermanagement.RemotePrint')
        }
      ],
      //地图弹出层控制变量
      innerVisible: false,
      innerVisibles: false,
      //搜索框
      seek: {
        userName: "",
        c_name: "",
        c_id: "",
        cContact: "",
        cTel: "",
        cEmail: "",
        cAddress: "",
        supportStatus: "",
        ckey:'',
        ckeyStatus:''
      },
      supportStatus: "",
      //排序对象
      sort: {
        cname: null, //客户名称（0，正序；1，倒序）
        cid: null, //客户id，不必须
        username: null, //管理员名，不必须
        contact: null, //联系人，不必须
        tel: null, //联系电话，不必须
        email: null, //邮箱，不必须
        address: null, //详细地址，不必须
        superlink: null, //服务类型
        ckey:null,
        ckeyStatus:null
      },
    };
  },
  components: {
    pagination,
    xlsx,
    UserMap,
    TableComponent,
    contDialog
  },
  mounted() {
    //获取中文或英文的权限列表
    this.queryKeyword(),
    //获取权限
    this.Permission = getPermission();
  },
  methods: {
    //获取客户列表
    getCustomerList() {
      getCustomerList(this.offset, this.limit).then(res => {
        if (res.data.data.list.length > 0) {
          this.list = res.data.data.list;
          this.total = res.data.data.total;
          this.offset = res.data.data.offset;
          this.limit = res.data.data.limit;
          this.list.unshift({});
        } else if ((res.data.data.list.length == 0) & (this.offset > 1)) {
          this.offset -= 1;
          getCustomerList(this.offset, this.limit).then(res => {
            this.list = res.data.data.list;
            this.total = res.data.data.total;
            this.offset = res.data.data.offset;
            this.limit = res.data.data.limit;
            this.list.unshift({});
          });
        }
      });
    },
    //新增客户上传
    newCustomer() {
      this.$refs.contDialog.show()
    },
    //删除客户
    deleteCustomer(row) {
      deleteCustomer(row.c_id).then(res => {
        this.offset = 1
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.customermanagement.message9"),
            type: "success"
          });
          
          this.queryKeyword()
        } else if (res.data.code == 19) {
          this.$message({
            showClose: true,
            message: this.$t("lang.customermanagement.message10"),
            type: "warning"
          });
          this.queryKeyword()
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.customermanagement.message11"),
            type: "warning"
          });
          this.queryKeyword()
        }
      });
    },
    //弹出修改客户信息框，拿到点击的客户信息
    modificationCustomer(row) {
      this.$refs.contDialog.show(row)
    },
    //搜索
    queryKeyword() {
      queryKeyword(
        [
          this.seek.userName,
          this.seek.c_name,
          this.seek.c_id,
          this.seek.cContact,
          this.seek.cTel,
          this.seek.cEmail,
          this.seek.cAddress,
          this.seek.supportStatus
        ],
        this.offset,
        this.limit,
        this.sort
      ).then(res => {
        this.total = res.data.data.total;
        this.limit = res.data.data.limit;
        this.offset = res.data.data.offset;
        // this.offset = 1
        this.list = res.data.data.list;
        this.list.unshift({});
      });
    },
    //表格排序
    sortChange(row) {
      //每次点击清空一次排序的赋值
      this.sort = {
        cname: null,
        cid: null,
        username: null,
        contact: null,
        tel: null,
        email: null,
        address: null,
        superlink: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (row.label != null) {
        label = row.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (row != null) {
        if (row.order == "ascending") {
          sortlist = 0;
        } else if (row.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.customermanagement.customerName")) {
        this.sort.cname = sortlist;
      } else if (label == this.$t("lang.customermanagement.Customer")) {
        this.sort.cid = sortlist;
      } else if (label == this.$t("lang.customermanagement.Admin")) {
        this.sort.username = sortlist;
      } else if (label == this.$t("lang.customermanagement.Contact")) {
        this.sort.contact = sortlist;
      } else if (label == this.$t("lang.customermanagement.phone")) {
        this.sort.tel = sortlist;
      } else if (label == this.$t("lang.customermanagement.Email")) {
        this.sort.email = sortlist;
      } else if (label == this.$t("lang.customermanagement.detailed")) {
        this.sort.address = sortlist;
      } else if (label == this.$t("lang.customermanagement.services")) {
        this.sort.superlink = sortlist;
      }
    },
    //获取客户服务类型
    GetServer(row){
      if(row.superlink[0].group!=0&&row.superlink[0].n2nInfoStatus==0){
        return this.$t("lang.customermanagement.ServiceClient")
      }else if(row.superlink[0].group!=0&&row.superlink[0].n2nInfoStatus==1){
        return 'SuperLink'
      }else if(row.superlink[0].group!=0&&row.superlink[0].n2nInfoStatus==2){
        return this.$t("lang.customermanagement.PrintCore")
      }else {
        return ''
      }
    }
  },
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
</style>
